import React from "react";

const TableIndexColumn = ({clickHandler, num}) => {
    return <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500" onClick={clickHandler}>
        {num}
    </td>
}

export default TableIndexColumn;